<div class="whats-new" [class.whats-new-mcp]="step.visual === 'mcp'">
  <!-- Header: product first, so it is clear in a second what changed -->
  <div class="whats-new-header">
    <div class="flex items-center gap-3">
      <mat-icon
        class="whats-new-product-icon"
        [svgIcon]="announcement.product.icon"
      ></mat-icon>
      <div class="leading-tight">
        <div class="whats-new-product">{{ announcement.product.label }}</div>
        <div class="whats-new-title">
          {{ announcement.title }}
          @if (announcement.badge) {
            <span class="whats-new-badge">{{ announcement.badge }}</span>
          }
        </div>
      </div>
    </div>

    <button
      class="whats-new-close"
      mat-icon-button
      (click)="close()"
      aria-label="Close"
    >
      <mat-icon
        class="text-current"
        [svgIcon]="'heroicons_outline:x-mark'"
      ></mat-icon>
    </button>
  </div>

  <!--
    Fixed geometry. The dialog must not resize between steps — a box that jumps
    around reads as broken and moves the buttons out from under the pointer.
  -->
  <div class="whats-new-stage">
    @for (s of announcement.steps; track s.title; let i = $index) {
      @if (i === stepIndex) {
        <!-- Re-created per step so the entrance animation runs again -->
        <div class="whats-new-step">
          <div
            class="whats-new-visual"
            [class.whats-new-visual-mcp]="s.visual === 'mcp'"
          >
            @switch (s.visual) {
              @case ('autoscaling') {
                <autoscaling-visual />
              }
              @case ('mcp') {
                <mcp-visual />
              }
            }
          </div>

          <div class="whats-new-copy" aria-live="polite">
            <h2>{{ s.title }}</h2>
            @if (s.body) {
              <p>{{ s.body }}</p>
            }

            @if (s.facts?.length) {
              <div class="whats-new-facts">
                @for (fact of s.facts; track fact.label) {
                  <div class="whats-new-fact">
                    <div class="whats-new-fact-label">
                      <mat-icon
                        class="icon-size-4 text-current"
                        [svgIcon]="'heroicons_solid:check-circle'"
                      ></mat-icon>
                      <span>{{ fact.label }}</span>
                    </div>
                    <div class="whats-new-fact-text">{{ fact.text }}</div>
                  </div>
                }
              </div>
            }
            @if (s.visual === 'mcp') {
              <div class="whats-new-mcp-url">
                <span>MCP server URL</span>
                <div>
                  <code>{{ mcpServerUrl }}</code>
                  <app-copy-button
                    [text]="mcpServerUrl"
                    tooltip="Copy MCP server URL"
                  />
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>

  <!-- Footer -->
  <div class="whats-new-footer">
    <!--
      Ticked by default: closing the dialog without touching it means "seen,
      thanks". Unticking asks for it again on the next visit.
    -->
    <mat-checkbox class="whats-new-dismiss" [(ngModel)]="dismissForGood">
      Don't show this again
    </mat-checkbox>

    <!-- Dots only earn their place when there is more than one screen -->
    @if (announcement.steps.length > 1) {
      <div class="flex items-center gap-2">
        @for (s of announcement.steps; track s.title; let i = $index) {
          <button
            type="button"
            class="whats-new-dot"
            [class.is-current]="i === stepIndex"
            [attr.aria-label]="
              'Step ' + (i + 1) + ' of ' + announcement.steps.length
            "
            [attr.aria-current]="i === stepIndex ? 'step' : null"
            (click)="goToStep(i)"
          ></button>
        }
      </div>
    }

    <div class="whats-new-actions">
      @if (!isFirstStep) {
        <button mat-button type="button" (click)="back()">Back</button>
      }

      @if (isLastStep) {
        @if (data.secondary) {
          <button
            mat-stroked-button
            type="button"
            (click)="runCta(data.secondary)"
          >
            {{ data.secondary.label }}
            @if (data.secondary.kind === 'external') {
              <mat-icon
                class="icon-size-4 ml-2"
                iconPositionEnd
                svgIcon="heroicons_outline:arrow-top-right-on-square"
              />
            }
          </button>
        }

        <!--
          Absent only when this build cannot reach the product at all. The label
          otherwise says what actually happens: the tutorial for a reader who
          has the product, activation for one who does not.
        -->
        @if (data.primary) {
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="runCta(data.primary)"
          >
            {{ data.primary.label }}
          </button>
        }
      } @else {
        <button mat-flat-button color="primary" type="button" (click)="next()">
          Next
        </button>
      }
    </div>
  </div>
</div>
